<template>
    <AdminLayout>
        <section class="flex items-start pl-6 pr-14 space-x-9">
            <div class="w-60 shrink-0 sticky top-20 mt-12 bg-white shadow-[-1px_1px_4px_1px_rgba(0,0,0,0.05)] rounded-md overflow-hidden">
                <ul>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_report'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'report' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'report'">
                        <span>Leave Report</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_status'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'status' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'status'">
                        <span>Leave Status</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_listing'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'listing' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'listing'">
                        <span>Leave Listing</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_settings'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'setting' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'setting'">
                        <span>Leave Setting</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_carry_forward'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'carry-request' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'carry-request'">
                        <span>Leave carry forward request (employee)</span>
                    </li>
                    <li v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_carry_admin'))" class="flex items-center space-x-2.5 text-sm font-medium flex-nowrap p-4 hover:text-[#3B82F6] transition-all cursor-pointer" :class="tab == 'carry-adjustment' ? 'bg-[#ECF6FF] text-[#3B82F6]' : 'bg-white text-[#767676]'" @click="tab = 'carry-adjustment'">
                        <span>Leave carry forward adjustment</span>
                    </li>
                </ul>
            </div>
            <div class="grow overflow-hidden py-2">
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_report')) && tab == 'report'">
                    <LeaveReport />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_status')) && tab == 'status'">
                    <LeaveStatus />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_listing')) && tab == 'listing'">
                    <LeaveListing />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_settings')) && tab == 'setting'">
                    <LeaveSetting />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_carry_forward')) && tab == 'carry-request'">
                    <LeaveCarryForwardPayouts />
                </div>
                <div v-if="role && (role.name === 'Super Admin' || role.permissions.includes('leave_carry_admin')) && tab == 'carry-adjustment'">
                    <LeaveCarryAdmin />
                </div>
            </div>
        </section>
    </AdminLayout>
</template>

<script>
import AdminLayout from "@/Pages/AdminDashboard/AdminLayout.vue";
import LeaveReport from "@/Pages/Settings/LeaveReport.vue";
import LeaveStatus from "@/Pages/Settings/LeaveStatus.vue";
import LeaveListing from "@/Pages/Settings/LeaveListing.vue";
import LeaveSetting from "@/Pages/Settings/LeaveSetting.vue";
import LeaveCarryForwardPayouts from "@/Pages/Settings/LeaveCarryForwardPayouts.vue";
import LeaveCarryAdmin from "@/Pages/Settings/LeaveCarryAdmin.vue";

export default {
    name: 'LeaveManagement',
    data() {
        return {
            tab: 'report',
            role: null
        }
    },
    components: {
        AdminLayout,
        LeaveReport,
        LeaveStatus,
        LeaveListing,
        LeaveSetting,
        LeaveCarryForwardPayouts,
        LeaveCarryAdmin
    },
    mounted() {
        const storedRole = localStorage.getItem("role");
        // console.log("Stored role:", storedRole);
        try {
            this.role = storedRole;
        // console.log("Parsed role:", this.role);
        //console.log("Permissions:", this.role.permissions);
            if (this.role.name === 'Super Admin') {
                this.tab = 'report'; // Default for Super Admin
            } else if (this.role.permissions.includes('leave_report')) {
                this.tab = 'report';
            } else if (this.role.permissions.includes('leave_status')) {
                this.tab = 'status';
            } else if (this.role.permissions.includes('leave_listing')) {
                this.tab = 'listing';
            } else if (this.role.permissions.includes('leave_settings')) {
                this.tab = 'setting';
            } else if (this.role.permissions.includes('leave_carry_forward')) {
                this.tab = 'carry-request';
            } else if (this.role.permissions.includes('leave_carry_admin')) {
                this.tab = 'carry-adjustment';
            }
        } catch (error) {
            console.error("Invalid role JSON", error);
        }
    },
    methods: {
    }
}
</script>